export * from "./speaker-bio-page.view";
